const SET_JWT_TOKEN_IN_LOCAL_SYNC_CONTROLLER = 'SET_JWT_TOKEN_IN_LOCAL_SYNC_CONTROLLER';


const setJWTTokenInLocalSyncController = (JWTToken) => ({
  type: SET_JWT_TOKEN_IN_LOCAL_SYNC_CONTROLLER,
  payload: {
    JWTToken,
  },
});

export {
  setJWTTokenInLocalSyncController,
  SET_JWT_TOKEN_IN_LOCAL_SYNC_CONTROLLER,
};

